(() => {
  const landers = document.querySelectorAll('[data-stono-quiz-lander]');

  landers.forEach((lander) => {
    const hero = lander.querySelector('[data-stono-quiz-lander-hero]');
    const stickyCta = lander.querySelector('[data-stono-quiz-lander-sticky]');

    if (!hero || !stickyCta || !('IntersectionObserver' in window)) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        const isVisible = !entry.isIntersecting;
        stickyCta.classList.toggle('is-visible', isVisible);
        document.body.classList.toggle('stono-quiz-lander-sticky', isVisible);
      },
      { threshold: 0 }
    );

    observer.observe(hero);

    document.addEventListener('shopify:section:unload', (event) => {
      if (event.target.contains(lander)) {
        observer.disconnect();
        document.body.classList.remove('stono-quiz-lander-sticky');
      }
    });
  });
})();
